<script setup>
import pluralize from "../../utilities/pluralize";

defineProps(['id', 'name', 'link', 'logo', 'count'])
</script>

<template>
    <a class="brand-logo" :href="link">
        <div class="logo-container" v-if="logo">
            <div class="logo">
                <img :src="logo ? logo.url : null" :width="logo ? logo.width : null" :height="logo ? logo.height : null" loading="lazy" decoding="async" alt="">
            </div>
        </div>

        <div class="description">
            <div class="title" v-html="name"></div>

            <div class="subtitle" v-html="pluralize(count, '%s model available', '%s models available')"></div>
        </div>
    </a>
</template>
